class LoanInstallmentCell extends UITableViewCell 
{
    awakeFromHTML(): void 
    {
    }
}